// extracted by mini-css-extract-plugin
export default {"tableBodyRowContainer":"TableBodyRow__tableBodyRowContainer--23f","tableBodyRowColumn":"TableBodyRow__tableBodyRowColumn--3Ul"};